import { apiFetch } from "./client.ts";

export interface Client {
  id: string;
  account_id: string;
  name: string | null;
  phone_e164: string;
  email: string | null;
  notes: string | null;
  preferred_locale: string;
  lifetime_value_cents: number;
  last_service_at: string | null;
  tags: string[] | null;
  opt_ins: Record<string, boolean> | null;
  created_at: string;
  updated_at: string;
}

export interface ClientList {
  items: Client[];
  total: number;
  limit: number;
  offset: number;
}

export interface ClientJob {
  id: string;
  job_number: number | null;
  title: string | null;
  status: string;
  scheduled_start: string | null;
  created_at: string;
}

export async function listClients(params: { q?: string; limit?: number; offset?: number } = {}): Promise<ClientList> {
  const usp = new URLSearchParams();
  if (params.q) usp.set("q", params.q);
  usp.set("limit", String(params.limit ?? 50));
  usp.set("offset", String(params.offset ?? 0));
  return apiFetch<ClientList>(`/clients?${usp}`);
}

export async function getClient(id: string): Promise<Client> {
  return apiFetch<Client>(`/clients/${id}`);
}

export async function createClient(payload: {
  name?: string | null;
  phone_e164: string;
  email?: string | null;
  notes?: string | null;
  preferred_locale?: string;
  tags?: string[] | null;
  opt_ins?: Record<string, boolean> | null;
}): Promise<Client> {
  return apiFetch<Client>("/clients", { method: "POST", body: JSON.stringify(payload) });
}

export async function updateClient(
  id: string,
  patch: { name?: string | null; phone_e164?: string | null; email?: string | null; notes?: string | null; preferred_locale?: string | null; tags?: string[] | null; opt_ins?: Record<string, boolean> | null },
): Promise<Client> {
  return apiFetch<Client>(`/clients/${id}`, { method: "PATCH", body: JSON.stringify(patch) });
}

export async function deleteClient(id: string): Promise<void> {
  await apiFetch<void>(`/clients/${id}`, { method: "DELETE" });
}

export async function getClientJobs(id: string, limit = 20): Promise<ClientJob[]> {
  return apiFetch<ClientJob[]>(`/clients/${id}/jobs?limit=${limit}`);
}
